/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_ContentInputs */

const cs_nav_section_content = /** @type {(inputs: Nav_Section_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsah`)
};

const en_nav_section_content = /** @type {(inputs: Nav_Section_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Nav_Section_ContentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_content = /** @type {((inputs?: Nav_Section_ContentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_ContentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_content(inputs)
	return cs_nav_section_content(inputs)
});